import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=3fd41e21&scoped=true&"
import script from "./UserDashboard.vue?vue&type=script&lang=js&"
export * from "./UserDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd41e21",
  null
  
)

export default component.exports